import { HttpService, Query, QueryHandler, TaggedUrl, Tags, transformDTODate } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';
import { Transform } from 'class-transformer';

export type SaleAdvanceHistoryGridItem = SaleAdvanceHistoryGridItemDTO;

class SaleAdvanceHistoryGridItemDTO {
    public id!: number;
    public advanceValue!: number;
    public documentNumber!: string;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly issueDate!: Date;
}
export class SaleAdvanceHistoryQuery extends Query<SaleAdvanceHistoryGridItem[]> {
    public constructor(public readonly documentId: number) {
        super();
    }
}

export class SaleAdvanceHistoryQueryHandlerBase implements QueryHandler<SaleAdvanceHistoryQuery> {
    private static Url = TaggedUrl.join('sales/:id/advances', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync(params: SaleAdvanceHistoryQuery): Promise<SaleAdvanceHistoryGridItem[]> {
        const url = fillPlaceholders(SaleAdvanceHistoryQueryHandlerBase.Url, { id: params.documentId });
        const { data } = await this.http.get<SaleAdvanceHistoryGridItemDTO[]>(url, {dto: SaleAdvanceHistoryGridItemDTO});

        return data.map(x => {
            return {
                id: x.id,
                advanceValue: x.advanceValue,
                issueDate: x.issueDate,
                documentNumber: x.documentNumber
            };
        });
    }
}
